/** PURE_IMPORTS_START ._GenerateObservable PURE_IMPORTS_END */
import { GenerateObservable } from './GenerateObservable';
export var generate = GenerateObservable.create;
//# sourceMappingURL=generate.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/observable/generate.js
// module id = 773
// module chunks = 0